import { Routes, Route } from "react-router-dom";
import Layout from "./Component/Layout";
import ScrollToTop from "./Component/ScrollToTop.jsx";
import HomePage from "./Pages/Home";
import GalleryPage from "./Pages/GalleryPage";
import ContactPage from "./Pages/ContactPage";
import PatreonPage from "./Pages/PatreonPage";
import AboutPage from "./Pages/AboutPage";
import Login from "./Pages/Login.jsx";
// import MembershipPage from "./Pages/MembershipPage.jsx";
import UserDashboard from "./Pages/UserDashboard.jsx";
import PlayerRegistration from "./Pages/PlayerRegistration.jsx";
import Registration from "./Pages/Registration.jsx";

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/patreon" element={<PatreonPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/playerregister" element={<PlayerRegistration />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />
        {/* <Route path="/membership" element={<MembershipPage />} /> */}
        <Route path="/userdashboard" element={<UserDashboard />} />
      </Routes>
    </Layout>
  );
}

export default App;